import { mining } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function timeCheck (option) {
  return mining.post('timeCheck.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function create (option) {
    return mining.post('create.do', option)
    .then((res) => {
        return checkLimitedUser(res)
      });
}

function check (option) {
    return mining.post('check.do', option)
    .then((res) => {
        return checkLimitedUser(res)
      });
}

function use (option) {
    return mining.post('use.do', option)
    .then((res) => {
        return checkLimitedUser(res)
      });
}

function main () {
    return mining.post('main.do', 
    {
        userKey: sessionStorage.getItem('userKey')
    })
    .then((res) => {
        return checkLimitedUser(res)
    });
}


export { timeCheck ,create, check, use, main }